<template>
  <div class="rooms-page">
    <room-slider :roomSlots="['livingroom', 'ads']">
      <template #livingroom>
        <livingroom />
      </template>
      <template #ads>
        <livingroom />
      </template>
    </room-slider>
  </div>
</template>

<script setup>
import RoomSlider from '../base/RoomSlider.vue';
import Livingroom from '../rooms/Livingroom.vue';
</script>

<style scoped>
.rooms-page {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: radial-gradient(circle, #f5e0c3, #f7d6a0, #f7a66c);
  text-align: center;
}
</style>
